import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import StoryCard from "@/components/StoryCard";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";
import { Heart, ShieldCheck } from "lucide-react";

export default function Stories() {
  const { t } = useLang();
  const [stories, setStories] = useState(null);

  useEffect(() => { api.get("/testimonials").then((r) => setStories(r.data)).catch(() => setStories([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">{t("stories.eyebrow")}</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">{t("stories.title")}</h1>
        <p className="text-muted-foreground mt-2">{t("stories.sub")}</p>
      </div>

      {stories === null ? (
        <p className="text-center text-muted-foreground py-16">{t("common.loading")}</p>
      ) : stories.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stories.map((s, i) => <StoryCard key={s.id} story={s} index={i} />)}
        </div>
      ) : (
        <div className="max-w-xl mx-auto text-center rounded-3xl border border-border bg-white p-10">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4"><Heart className="w-7 h-7 text-primary" /></div>
          <h2 className="font-heading text-2xl font-bold">{t("stories.emptyTitle")}</h2>
          <p className="text-muted-foreground mt-3" dangerouslySetInnerHTML={{ __html: t("stories.emptySub") }} />
          <Link to="/share-your-story"><Button className="rounded-full mt-6 px-6" data-testid="stories-share-btn">{t("stories.share")}</Button></Link>
        </div>
      )}

      {stories && stories.length > 0 && (
        <div className="text-center mt-12 rounded-3xl bg-primary/5 border border-primary/10 p-8">
          <ShieldCheck className="w-8 h-8 text-primary mx-auto" />
          <h3 className="font-heading text-xl font-bold mt-2">{t("stories.ctaTitle")}</h3>
          <p className="text-muted-foreground mt-1">{t("stories.ctaSub")}</p>
          <Link to="/share-your-story"><Button className="rounded-full mt-4 px-6" data-testid="stories-share-btn-2">{t("stories.share")}</Button></Link>
        </div>
      )}
    </div>
  );
}
